import React from "react";

const SyncProgressBar = ({ progress }) => {
  const { current, total } = progress;
  const percentage = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;

  if (percentage === 0 || percentage === 100) return null;

  return (
    <div className="progress my-2" style={{ height: "20px" }}>
      <div
        className="progress-bar progress-bar-striped progress-bar-animated bg-info"
        role="progressbar"
        style={{ width: `${percentage}%` }}
        aria-valuenow={percentage}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {percentage}% Syncing...
      </div>
    </div>
  );
};

export default SyncProgressBar;
